module.exports = __webpack_public_path__ + "img/delivery_success.776ac705.png";